import axios from '../../config/axiosConfig';
import { CREATE_TRANSPORTER, GET_TRANSPORTERS, TRANSPORTER_REQUEST, DELETE_TRANSPORTER, UPDATE_TRANSPORTER, TRANSPORTER_REQUEST_FAILURE } from '../types';
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getTransporters = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: TRANSPORTER_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            return axios.get('/transporter/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_TRANSPORTERS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createTransporter = (transporter) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: TRANSPORTER_REQUEST });

            return axios.post('/transporter/add', transporter,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_TRANSPORTER, payload: response.data });
                    dispatch(addMasterInOption('transporters', response.data));
                } else {
                    dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: 'Transporter create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateTransporter = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: TRANSPORTER_REQUEST });
            return axios.put('/transporter/update', { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_TRANSPORTER, payload: { id, data: response.data } });
                    dispatch(updateMasterInOption('transporters', id, response.data));
                } else {
                    dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: 'Transporter update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteTransporter = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: TRANSPORTER_REQUEST });
            return axios.delete(`/transporter/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_TRANSPORTER, id: id });
                    dispatch(updateMasterInOption('transporters', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: TRANSPORTER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};